import FailedUsersRoomsModel from '../Apis/FailedUsersRooms'
import Controller from './Controller'

export default class FailedUsersRoomsController extends Controller {
  constructor() {
    super(new FailedUsersRoomsModel())
  }
}
